module.exports = __webpack_public_path__ + "assets/img/002.eaff0566.png";